export class Model {
    constructor(baseState) {
        this.setState = (state) => {
            this.prevState = this.state;
            this.state = state;
            this.fire();
        };
        this.getState = () => {
            return structuredClone(this.state);
        };
        this.unsubscribe = (index) => {
            this.subscribers.splice(index, 1, () => null);
        };
        this.subscribe = (callback) => {
            this.subscribers.push(callback);
            return this.subscribers.length - 1;
        };
        this.fire = () => {
            this.subscribers.forEach((callback) => {
                callback(this.state, this.prevState);
            });
        };
        this.prevState = null;
        this.state = baseState;
        this.subscribers = [];
    }
}
